import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import axiosInstance from '../axiosInstance';
import MyChatComponent from './MyChatComponent'; // Import MyChatComponent
import MyUserContext from '../myUserContext'; // Import MyUserContext

const ArtEventDropdown = ({ eventId, onClose, language, eventType="artEvent", initialArtEvent = null }) => {
  const myUser = useContext(MyUserContext);
  const navigate = useNavigate(); // Initialize useNavigate
  const [artEvent, setArtEvent] = useState(initialArtEvent);

  const dropdownRef = useRef(null);

  const updateArtEvent = () => {
    if (initialArtEvent) {
      return; // Skip fetching if initialArtEvent is provided
    }

    if (eventType === 'recommendation') { // it will live, or not
      axiosInstance
      .get(`/recommendations/${eventId}`)
      .then((response) => {
        setArtEvent({
          event: response.data.recommendation,
          art: response.data.art,
          fromUser: response.data.fromUser,
          toUser: response.data.toUser,
          chat: response.data.chat,
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }

    if (eventType === 'artEvent') {
      axiosInstance
      .get(`/artEvents/${eventId}`)
      .then((response) => {
        setArtEvent({
          event: response.data.event,
          art: response.data.art,
          chat: response.data.chat,
          eventOwnerUserName: response.data.eventOwnerUserName,
          eventOwnerUserAvatarUrl: response.data.eventOwnerUserAvatarUrl
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }
  };

  useEffect(() => {
    updateArtEvent();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        event.type === "mousedown"
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    const preventParentInteraction = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        event.preventDefault(); // Prevent parent scrolling only if the event is outside the dropdown
      }
    };

    document.body.style.overflow = 'hidden'; // Prevent parent scrolling
    document.addEventListener('touchmove', preventParentInteraction, { passive: false });
    document.addEventListener('wheel', preventParentInteraction, { passive: false });

    return () => {
      document.body.style.overflow = ''; // Restore parent scrolling
      document.removeEventListener('touchmove', preventParentInteraction);
      document.removeEventListener('wheel', preventParentInteraction);
    };
  }, []);

  if (!artEvent) {
    return <div></div>;
  }
  
  let actualEventType = eventType;
  if (eventType === "artEvent") {
    if (artEvent.event.type === 1) {
      actualEventType = "finished";
    } else if (artEvent.event.type === 2) {
      actualEventType = "todo";
    } else if (artEvent.event.type === 3) {
      actualEventType = "like";
    }
  } // else it's recommendation

  return (
    <div
      ref={dropdownRef}
      className="pb-20 md:pb-0 fixed inset-x-0 bottom-0 bg-[#5D6064] border-t border-gray-500 shadow-lg max-h-[75vh] overflow-y-auto z-50 w-full sm:max-h-[50vh]"
    >
      <div className="sticky top-0 z-10 bg-[#5D6064] text-center py-2">
        <img
          src="/drag_down_icon.png"
          alt="Drag Down Icon"
          className="w-6 h-6 mx-auto cursor-pointer"
          onClick={onClose}
        />
      </div>
      <div class="flex justify-center text-center items-center mt-1 mb-2 space-x-2 font-bold">
          {language === "ru" ? "Чат в моей библиотеке" : "Chat in my library"}
      </div>
      <div 
        className="text-sm text-center text-gray-300 mb-2 cursor-pointer hover:text-gray-100"
        onClick={() => navigate(`/artEvents/${artEvent.event.id}`)} // Use navigate
      >
        {language === "ru" ? "Перейти к произведению в моей библиотеке" : "Go to art in my library"}
      </div>

      <MyChatComponent key={artEvent.event.chatId} chatId={artEvent.event.chatId} userChatInfo={artEvent.chat} language={language} myUserInfo={myUser ? myUser.myUserInfo : null} chatOwnerInfo={{type:eventType, id: artEvent.event.id}} isDropdown={true}/>

    </div>
  );
};

export default ArtEventDropdown;
